export class Config {
  private static get props(): ConfiguratorProps | undefined {
    return (window as any).__CONFIGURATOR_PROPS__;
  }

  public static getBaseUrl(): string {
    return this.props?.baseUrl || "";
  }

  public static getOptions(): Record<string, unknown> {
    return this.props?.options || {};
  }

  public static getCatalogBrand(): string {
    return this.props?.catalogBrand || "";
  }

  public static getCatalogItemType(): string {
    return this.props?.catalogItemType || "";
  }

  public static getInitialItem(): string {
    return this.props?.initialItem || "";
  }

  public static getViewMode(): string {
    return this.props?.viewMode || "";
  }

  public static getCountry(): string {
    return this.props?.country || "";
  }

  public static getLanguage(): string {
    return this.props?.language || "";
  }

  /**
   * get shopUrl from config if exist and starts with http or https
   * @returns
   */
  public static getShopUrl(): string {
    return this.props?.shopUrl?.startsWith("http") ? this.props?.shopUrl : "";
  }

  /**
   * get the shop url button text from config
   */
  public static getShopUrlButtonText(): string {
    return this.props?.shopUrlButtonText || "";
  }

  public static getCatalogBanners(): {
    imageSrc: string
    alt: string
    eyebrow: string
    title: string
  }[] {
    return this.props?.catalogBanners || [];
  }

  public static getCatalogFilters(): ConfiguratorFilter {
    return this.props?.catalogFilters || {};
  }
}
